import script from "./Register.vue?vue&type=script&lang=ts&setup=true"
export * from "./Register.vue?vue&type=script&lang=ts&setup=true"

import "./Register.vue?vue&type=style&index=0&id=5174fcbc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5174fcbc"]])

export default __exports__